import React from "react";
import { DataTable } from "@sscs/ui";
import { selectSort, sortUpdated } from "../../../store/filesDiffSlice";
import { useReportDispatch, useReportSelector } from "../../hooks";
import FileChange from "./FileChange";
const COLUMNS = [
    { id: "info", label: "Info", width: "100px" },
    { id: "change", label: "File change", width: "150px" },
    {
        id: "file_path",
        label: "File path",
        sortProperty: "file_path",
        sortId: "diff-modified-sort-file-path",
        width: "50%",
    },
    {
        id: "file_name",
        label: "File name",
        sortProperty: "file_name",
        sortId: "diff-modified-sort-file-name",
        width: "50%",
    },
    {
        id: "changes_count",
        label: "Changes count",
        sortProperty: "changes_count",
        sortId: "diff-modified-sort-changes-count",
        startReverse: true,
        align: "right",
        width: "180px",
    },
];
const DiffFileList = ({ files, status, itemCount, pagination, filters, onPaginationChange, }) => {
    const dispatch = useReportDispatch();
    const sort = useReportSelector(selectSort);
    const handleSortChange = (value) => {
        dispatch(sortUpdated(value));
    };
    return (React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, status: status, empty: { subject: "files", filters }, pagination: {
            id: "diff-modified-pagination",
            itemCount,
            pagination,
            onChange: onPaginationChange,
        } }, files.map((file, index) => (React.createElement(FileChange, { rowIndex: index, key: file.id, file: file })))));
};
export default DiffFileList;
//# sourceMappingURL=DiffFileList.js.map